/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialAnalyticsResumeResponse } from '../../models/editorial-analytics-resume-response';

export interface GetEditorialAnalyticsResume$Params {
  companyId?: number;
}

export function getEditorialAnalyticsResume(http: HttpClient, rootUrl: string, params?: GetEditorialAnalyticsResume$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialAnalyticsResumeResponse>> {
  const rb = new RequestBuilder(rootUrl, getEditorialAnalyticsResume.PATH, 'get');
  if (params) {
    rb.query('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialAnalyticsResumeResponse>;
    })
  );
}

getEditorialAnalyticsResume.PATH = '/api/editorial/analytics/analytics-resume';
